/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ConvertInputs */



/**
* | output |
* | --- |
* | "Convert" |
*
* @param {ConvertInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const convert = /** @type {((inputs?: ConvertInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ConvertInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Convertir")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konvertieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Convertire")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Преобразовать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Convertir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("转变")
	if (locale === "ja") return /** @type {LocalizedString} */ ("変換する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बदलना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Converter")
	return /** @type {LocalizedString} */ ("Convert")
});